import template from './AuctionHint.jade';

export const AuctionHint = () => {
  return {
    template,
    scope: {},
    bindToController: {
      trigger: '@?',
      placement: '@?',
    },
    controllerAs: 'auctionHint',
    replace: true,
  };
};
